import { useAppSelector } from 'src/app/store/hooks';
import { useTripsBulkCancelReasonsCreateQuery } from 'src/common/external/bambi-api/bambiApi';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

/**
 *
 * This is meant to be used with bulk cancel when multiple trips have been selected
 * and we only want to make a single request to get the cancel reasons for all selected trips
 */
export function useTripCancelReasonsForTripWithBulkCancel(
  tripId: string
): ReturnType<typeof useTripsBulkCancelReasonsCreateQuery> & {
  reasons: SelectOption[];
} {
  const tripsToCancel = useAppSelector(
    (state) => state.trip.bulkCancelModal.tripsToCancel
  );

  const bulkCancelResultWithSelectedReasons =
    useTripsBulkCancelReasonsCreateQuery(
      {
        bulkTripCancelReasons: {
          trip_ids: tripsToCancel.map((trip) => trip.id),
        },
      },
      {
        skip: tripsToCancel.length === 0,
        selectFromResult: (result) => {
          const rawTripReasons =
            result.data?.results.find((result) => {
              return result.trip_id === tripId;
            })?.cancel_reasons || [];
          const reasons: SelectOption[] = rawTripReasons.map((reasonObj) => ({
            value: reasonObj.value || '',
            label: reasonObj.label,
          }));

          return {
            ...result,
            reasons,
          };
        },
      }
    );

  return bulkCancelResultWithSelectedReasons;
}
